"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useDynamicQuickLinks = (value, quickLinksProps) => {
  const [baseURLCheck, setBaseURLCheck] = (0, _react.useState)(false);
  const [baseURLs, setBaseURLs] = (0, _react.useState)({
    domain_search: '',
    help_center: ''
  });
  const getBaseURL = key => {
    if (quickLinksProps.quickLinks.length > 0) {
      quickLinksProps.quickLinks.forEach(quickLink => {
        if (quickLink._name === key) {
          setBaseURLs(urls => ({
            ...urls,
            ...{
              [key]: quickLink.href
            }
          }));
          if (key === 'help_center') {
            quickLink.href += '?src=site_search';
          }
        }
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (!baseURLCheck) {
      Object.keys(baseURLs).forEach(key => {
        getBaseURL(key);
      });
      setBaseURLCheck(true);
    }
  }, []);
  (0, _react.useEffect)(() => {
    const queryParams = {
      domain_search: '/domainsearch/find?itc=site_search_dpp&domainToCheck={queryParams}',
      help_center: '/search?q={queryParams}&types=Article&types=Video&src=site_search'
    };
    if (value) {
      const searchTerm = value.replace(' ', '+');
      quickLinksProps = quickLinksProps.quickLinks?.length > 0 ? quickLinksProps.quickLinks.map(quickLink => {
        let baseURL;
        if (baseURLs[quickLink._name]) {
          baseURL = baseURLs[quickLink._name].replace(/\/domains|\?src=site_search/g, '');
        } else {
          return quickLink;
        }
        const params = queryParams[quickLink._name] ? queryParams[quickLink._name].replace('{queryParams}', searchTerm) : null;
        quickLink.href = quickLink && quickLink.href && quickLink._name && searchTerm !== '' && queryParams[quickLink._name] ? `${baseURL}${params}` : baseURLs[quickLink._name];
        return quickLink;
      }) : null;
    }
  }, [value, baseURLs, quickLinksProps]);
  return quickLinksProps;
};
var _default = exports.default = useDynamicQuickLinks;